import { render, staticRenderFns } from "./ViewInstructions.vue?vue&type=template&id=3fc1b0b4&"
import script from "./ViewInstructions.vue?vue&type=script&lang=js&"
export * from "./ViewInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports